module.exports = "././img/QLD_CoA_Website_LOGO.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/QLD_CoA_Website_LOGO.svg
// module id = 815
// module chunks = 0